/**
 * 本部モジュール。
 *
 * **共通サマリー5行の契約(DepartmentModule)の初回実装。**
 * 全社PLはこの5行の単純合算のみで構成される(CLAUDE.md)。
 * 事業部固有の計算がどれだけ複雑になっても、この型と戻り値の意味は変えないこと。
 *
 * 本部は全社の経費システムを担う事業部で、現時点では独自の売上・原価を持たない。
 * 経費(確定済み)のみが実績として立つ。
 */
import {
  fetchBudgets,
  fetchBookedTransactions,
  fetchPendingTransactions,
  summarizeBudgets,
  summarizeTransactions,
} from '@core/pl/plRepo';
import type {
  Account,
  DepartmentModule,
  DepartmentSummary,
  MonthStr,
  SummaryLine,
} from '@core/lib/types';

export const HONBU_DEPARTMENT_ID = 'honbu' as const;

export function createHonbuModule(accounts: Account[]): DepartmentModule {
  return {
    departmentId: HONBU_DEPARTMENT_ID,
    async getMonthlySummary(month: MonthStr): Promise<DepartmentSummary> {
      const [confirmed, budgets] = await Promise.all([
        fetchBookedTransactions(HONBU_DEPARTMENT_ID, month),
        fetchBudgets(HONBU_DEPARTMENT_ID, month),
      ]);
      return {
        budget: summarizeBudgets(budgets, accounts),
        actual: summarizeTransactions(confirmed, accounts),
      };
    },
  };
}

/**
 * 参考表示用の見込み額(承認済・領収書提出済)。
 * **実績(actual)には含めない。** 画面で「見込み」として別に示すためだけに使う。
 */
export async function getHonbuPendingSummary(
  month: MonthStr,
  accounts: Account[],
): Promise<SummaryLine> {
  const pending = await fetchPendingTransactions(HONBU_DEPARTMENT_ID, month);
  return summarizeTransactions(pending, accounts);
}
